import UndoButton from '../Editor/ButtonDiv/Panel/UndoBtn';

interface InvalidFacetEditToastProps {
	shouldDisable?: boolean;
	label?: string;
	message?: string;
	showUndo?: boolean;
	labelStyle?: 'heading' | 'message';
	showExit?: boolean;
	onExit?: () => void;
}

export default function InvalidFacetEditToast({
	shouldDisable = false,
	label = 'Invalid edit detected.',
	message = 'Please undo your recent changes to fix it.',
	showUndo = true,
	labelStyle = 'heading',
	showExit = false,
	onExit
}: InvalidFacetEditToastProps) {
	return (
		<div>
			<div className={labelStyle === 'message' ? 'invalid-label invalid-label--top-align' : 'invalid-label'}>
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
					<path d="M9.30589 0.402197C9.01007 -0.134066 8.09011 -0.134066 7.79428 0.402197L0.0994104
							14.3417C0.0304034 14.4667 -0.00373071 14.6067 0.00032327 14.748C0.00437725 14.8894 0.0464816
							15.0273 0.122547 15.1485C0.198612 15.2696 0.306052 15.3698 0.434432 15.4394C0.562812 15.509
							0.707767 15.5455 0.855218 15.5455H16.245C16.3924 15.5457 16.5374 15.5094 16.6658
							15.4399C16.7943 15.3705 16.9017 15.2703 16.9778 15.1491C17.0538 15.028 17.0958 14.89
							17.0997 14.7486C17.1036 14.6073 17.0692 14.4674 16.9999 14.3426L9.30589 0.402197Z"
					fill="#f7b543"></path>
					<path d="M7.69531 13.0848H9.40528V11.4449H7.69531V13.0848Z" fill="white"></path>
					<path d="M7.69531 5.70508V9.80494H9.40614L9.40528 5.70508H7.69531Z" fill="white"></path>
				</svg>
				<label className={labelStyle === 'message' ? 'invalid-label--message-font' : undefined}>{label}</label>
				{showExit && (
					<button
						id="exit-map-only-btn"
						type="button"
						className="strip"
						onClick={onExit}
					>
						Exit
					</button>
				)}
			</div>
			{message && (
				<div className='undo-toast-wrap'>
					<span>{message}</span>
					{showUndo && <UndoButton label="Undo" disabled={shouldDisable} />}
				</div>
			)}
		</div>
	);
}
